import RecentUploadsCarousel from './RecentUploadsCarousel'
export default RecentUploadsCarousel
